import React, { useEffect, useRef } from "react";
import "./MouseShadow.css";

function MouseShadow() {
  const shadowRef = useRef(null);

  useEffect(() => {
    const handleMouseMove = (e) => {
      const shadow = shadowRef.current;
      if (shadow) {
        shadow.style.left = `${e.clientX}px`;
        shadow.style.top = `${e.clientY}px`;
      }
    };

    window.addEventListener("mousemove", handleMouseMove);
    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, []);

  return <div className="mouse-shadow" ref={shadowRef}></div>;
}

export default MouseShadow;
